<template>
  <div class="container h-full mx-auto">
    <div
      class="relative flex flex-col h-screen mx-auto bg-cover border border-black"
      :style="{ backgroundImage: 'url(' + bg + ')' }"
    >
      <div ref="navbar" class="relative top-0" :style="{ height: '7%' }">
        <NavBar>
          <template slot="prev">
            <button
              class="block w-full py-2 font-bold text-center text-white sm:text-xl button v:py-4 sm:py-3"
              @click="prev"
            >
              이전으로
            </button>
          </template>
        </NavBar>
      </div>
      <!--end::NavBar-->

      <div class="relative flex-1 h-full">
        <PerfectScrollbar class="h-full">
          <slot />

          <BaseCopyright />
        </PerfectScrollbar>
      </div>
      <!--end::slot-->
    </div>
  </div>
</template>

<script>
import NavBar from '@components/game/nav-bar.vue'
import BaseCopyright from '@components/_base-copyright.vue'

export default {
  name: 'MainLayout',
  components: { BaseCopyright, NavBar },
  data() {
    return {
      bg: require('@assets/images/bg-main.png'),
    }
  },
  methods: {
    prev() {
      window.history.back()
    },
  },
}
</script>
